export default __webpack_public_path__ + "static/card_img-5-5a01e58c17fbc66d1f01c6f7d089973d.jpg";